<template>
  <a>
    <span
      class="modal-body-text">You are about to move <span class="event-name">{{moveEventData.eventName}}</span> to <span
      class="event-status">{{moveEventData.updateStatus}}</span></span><br/><br/>
    <span class="modal-body-text">If this client has email notifications on, they will recieve an email regarding the move.</span>
    <br/>
  </a>
</template>

<script>
  export default {
    name: 'admin-action-modal',
    props: {
      moveEventData: {
        type: Object,
        default: {}
      }
    }
  }
</script>

<style lang="less">
  .event-name {
    color: #0080A5;
    font-size: 14px;
    font-weight: bold;
    line-height: 18px;
  }

  .event-status {
    font-weight: bold;
    text-transform: capitalize;
  }
</style>




// WEBPACK FOOTER //
// MoveEvent.vue?6a26dfd7